export default __webpack_public_path__ + "static/media/medium.22ca50e8.png";